import React, { Component, Fragment } from 'react';
import Page from 'shared/Page';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { getListingSettings } from 'checkout/selectors/ui';
import TicketsButtonContainer from 'checkout/containers/TicketsButtonContainer';
import ListingBanner from '../components/ListingBanner';
import ListingDetails from '../components/ListingDetails';
import Footer from '../components/Footer';
import ContinueCheckoutBannerContainer from './ContinueCheckoutBannerContainer';
import ContactInfo from '../components/ContactInfo';
import ListingDatePicker from '../../checkout/views/series/containers/ListingDatePicker';
import KioskListing from 'listing/components/KioskListing';
import KioskManagement from 'listing/views/kiosk-management/containers/KioskManagement';
import HelpContainer from 'listing/views/help/containers/HelpContainer';
import KioskMonitoring from 'listing/views/kiosk-management/containers/KioskMonitoring';
import KioskTimeContainer from '../../checkout/views/kiosk/containers/KioskTimeContainer';
import TimeClock from '../../checkout/views/time/components/TimeClock';
import NextAvailableTime from '../../checkout/views/series/containers/NextAvailableTime';
import SoldOutDayDisplay from '../../checkout/views/series/containers/SoldOutDayDisplay';
import RefreshListingData from '../../checkout/components/RefreshListingData';
import TicketsGoOnSale from '../components/TicketsGoOnSale';
import TimeoutPromptContainer from '../../checkout/views/timeout-prompt/containers/TimeoutPromptContainer';
import clsx from 'clsx';
import { getSeriesOption } from '@v/series/selectors/eventSeries';
import { MemberLogin } from '../components/MemberLogin';
import MemberAuthButtons from 'checkout/components/MemberAuthButtons';
import TicketPickerContainer from '@v/ticket-picker/containers/TicketPickerContainer';
import InventoryContentContainer from '@v/ticket-picker/containers/InventoryContentContainer';
import InventoryItemsContainer from '@v/ticket-picker/containers/InventoryItemsContainer';
import CouponAlertsContainer from '@v/ticket-picker/containers/CouponAlertsContainer';
import AlertContainer from '@v/cart/containers/AlertContainer';
import InventoryFooterContainer from '@v/ticket-picker/containers/InventoryFooterContainer';
import InventoryErrors from '@v/ticket-picker/containers/InventoryErrors';
import FeeDisclosure from '@v/ticket-picker/containers/FeeDisclosure';
import CheckoutButton from '@v/ticket-picker/containers/CheckoutButton';
import CouponEntryButton from '@v/ticket-picker/containers/CouponEntryButton';
import { TICKETS_DISPLAY_LIST } from '@b/checkout/reducers/ui';
import { withNavigation } from '@b/helpers/withNavigation';
import NavigationService from '@/components/NavigationService';
import { refreshMembershipStatus } from '@/actions/ui';
import { PageContentWithTabs } from '@b/listing/components/PageContentWithTabs';
import ListingEventDetails from '@b/listing/components/ListingEventDetails';

/**
 * Extends the Page component, which holds the code for rendering out
 * the components
 */

class Listing extends Page {

    map = {
        ticketsButton:          TicketsButtonContainer,
        memberAuthButtons:      MemberAuthButtons,
        continueCheckoutBanner: ContinueCheckoutBannerContainer,
        listingBanner:          ListingBanner,
        listingDetails:         ListingDetails,
        contactInfo:            ContactInfo,
        footer:                 Footer,
        listingDatePicker:      ListingDatePicker,
        KioskListing:           KioskListing,
        KioskManagement:        KioskManagement,
        HelpContainer:          HelpContainer,
        KioskMonitoring:        KioskMonitoring,
        KioskTimeContainer:     KioskTimeContainer,
        TimeClock:              TimeClock,
        NextAvailableTime:      NextAvailableTime,
        SoldOutDayDisplay:      SoldOutDayDisplay,
        RefreshListingData:     RefreshListingData,
        TicketsGoOnSale:        TicketsGoOnSale,
        TimeoutPromptContainer: TimeoutPromptContainer,
        MemberLogin:            MemberLogin,
        TicketPickerContainer,
        InventoryContentContainer,
        InventoryItemsContainer,
        CouponAlertsContainer,
        AlertContainer,
        InventoryFooterContainer,
        InventoryErrors,
        FeeDisclosure,
        CheckoutButton,
        CouponEntryButton,
        PageContentWithTabs,
        ListingEventDetails,
    };

    componentDidMount() {
       window.scrollTo(0,0);
       this.props.refreshMembershipStatus();
    }

    render() {
        const ticketsListType = this.props?.ticketsDisplayType === TICKETS_DISPLAY_LIST;

        return(
            <Fragment>
                <main
                  className={clsx('page', {
                    'page--series': this.props.calendarOnListing,
                    'page--pro': this.props.isPro,
                  })}
                  id={ticketsListType ? 'checkout-inline': 'page'}
                >
                    {!this.props.loading
                      ? this.getComponents()
                      : (
                        <div className="listing--loading-state">
                            <i className="icon-spinner loading__spinner" aria-hidden="true" />
                        </div>
                      )
                    }
                </main>
                <div className="overlay"></div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        settings: getListingSettings(state),
        loading: state.event.loading,
        calendarOnListing: !!getSeriesOption("calendarOnListing", false)(state),
        ticketsDisplayType: state.ui.uiConfig.listings?.ticketsDisplayType,
        isPro: state.ui.uiConfig.isPro,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
      refreshMembershipStatus,
    }, dispatch);
}

Listing.propTypes = {
}

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(Listing))
